import { render } from "./SaveJobCategory.vue?vue&type=template&id=5dab719e"
import script from "./SaveJobCategory.vue?vue&type=script&lang=js"
export * from "./SaveJobCategory.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/hrm/src/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__